import { ApolloProvider } from '@apollo/client';
import { ClientLoaderFunction } from 'react-router';
import { getApolloClient } from '@/apollo/apollo-client-instance';
import { AuthGuardProvider } from '@/components/auth-guard/auth-guard-provider';
import { RootThemeProvider } from '@/components/root-theme-provider';
import {
  appSessionClientMiddleware,
  appSessionMiddleware,
} from '@/session-middleware';
import { AppContent } from './app-content';
import { appLoader } from './loader';
import { SidebarProvider } from './sidebar/sidebar-provider';
import { SplashScreen } from './splash-screen';

export const middleware = [appSessionMiddleware];
export const clientMiddleware = [appSessionClientMiddleware];

export const clientLoader: ClientLoaderFunction = appLoader;
clientLoader.hydrate = true;

export const HydrateFallback = () => <SplashScreen />;

export default function App() {
  return (
    <SidebarProvider>
      <ApolloProvider client={getApolloClient()}>
        <RootThemeProvider>
          <AuthGuardProvider>
            <AppContent />
          </AuthGuardProvider>
        </RootThemeProvider>
      </ApolloProvider>
    </SidebarProvider>
  );
}
